import jQuery from 'jquery';

import * as segmentio from 'rp-analytics';
import { analyticsPage } from '../analyticsPage';

import deviceDetect from './deviceDetect';
import cardPage from './cardPage';

const popoverSelectedClass = 'RC-chooseBookieMobileExperiment--selected';
const bookmakersContainerSelector = '.RC-chooseBookieMobileExperiment__bookmakerContainer';
const bookmakerSelector = '.js-RC-chooseBookieMobileExperiment__bookmaker';
const closeButtonClass = 'RC-chooseBookieMobileExperiment__closeButton';
const logInSelector = '.js-RC-chooseBookieMobileExperiment__accountBtn--logIn';
const logOutSelector = '.js-RC-chooseBookieMobileExperiment__accountBtn--logOut';
const registerSelector = '.js-RC-chooseBookieMobileExperiment__accountBtn--register';
const linkSelector = '.js-RC-chooseBookieMobileExperiment__link';
const bookmakerSelectedClass = 'RC-chooseBookieMobileExperiment__bookmaker--selected';
const accountSelector = '.RC-chooseBookieMobileExperiment__account';
const overlayClass = 'RC-chooseBookieMobileExperiment__overlay';
const signedInClass = 'signedIn';
const configBookieNames = {
    WH_OXI: 'William Hill',
    LADB: 'Ladbrokes',
    PPWR: 'Paddy Power',
    BETFAIR: 'Betfair',
    CORAL: 'Coral',
    SURREY: 'Skybet'
};

export default class ChooseBookieExperiment {
    constructor(isOnLoad) {
        this.$template = jQuery('.js-RC-chooseBookieMobileExperiment');
        this.isOnLoad = isOnLoad;
        this.eventsAreBound = false;
        this.bindEvents = this.bindEvents.bind(this);
    }

    init() {
        if (!deviceDetect.phone() || (this.isOnLoad && jQuery.cookie('chooseBookie'))) {
            this.$template.remove();
            return jQuery.Deferred().resolve();
        }

        if (this.isOnLoad) {
            jQuery(`.${closeButtonClass}`).addClass(`${closeButtonClass}--hidden`);
        }

        this.shuffleBookmakerNodes();

        this.bindEvents(false);
        const deferred = jQuery.Deferred();
        this.resolvePromise = deferred.resolve;
        if (!this.isOnLoad) {
            this.resolvePromise();
        }
        return deferred.promise();
    }

    bindEvents(isCalledExternally) {
        if (this.isOnLoad || isCalledExternally) {
            this.showLightbox();
        }

        if (!this.eventsAreBound) {
            this.$template
                .on('click', bookmakerSelector, this.onButtonClick.bind(this))
                .on('click', logInSelector, this.logInBookieHandler.bind(this))
                .on('click', registerSelector, this.registerBookieHandler.bind(this))
                .on('click', logOutSelector, this.logOutBookieHandler.bind(this))
                .on('click', `.${closeButtonClass}`, this.closeModal.bind(this));
            this.eventsAreBound = true;
        }
    }

    showLightbox() {
        const config = {
            cssClass: 'RC-modal_chooseBookieMobileExperiment',
            showClose: false,
            autoClose: false,
            overlayCssClass: overlayClass,
        };
        const $overlayNode = jQuery(`.${overlayClass}`);
        const $selectedBookmaker = this.getSelectedBookmakerNode();

        analyticsPage({
            'Choose Your Bookie': 'true'
        });
        cardPage.removeScroll();

        if (!this.isOnLoad && $selectedBookmaker[0]) {
            this.selectBookmaker($selectedBookmaker);
            const accountInfo = this.getAccountInfo($selectedBookmaker.attr('data-feed'));

            if (accountInfo.isLoggedIn) {
                this.setSignedInBookmaker($selectedBookmaker);
            } else {
                this.setSignedOutBookmaker($selectedBookmaker);
            }
        }

        if ($overlayNode[0]) {
            $overlayNode.show();
        } else {
            this.$template.rpModalBox(config);
        }
    }

    shuffleBookmakerNodes() {
        let $bookmakerNodes;
        const choosebookieOrder = JSON.parse(sessionStorage.getItem('choosebookieOrder')) || [];
        const $bookmakerContainer = jQuery(bookmakersContainerSelector);

        if (choosebookieOrder && choosebookieOrder.length) {
            $bookmakerNodes = choosebookieOrder.map(feed => jQuery(`${bookmakerSelector}[data-feed="${feed}"]`));
        } else {
            $bookmakerNodes = jQuery(bookmakerSelector).sort(() => 0.5 - Math.random());

            for (let i = 0; i < $bookmakerNodes.length; i += 1) {
                choosebookieOrder[i] = jQuery($bookmakerNodes[i]).data('feed');
            }
            sessionStorage.setItem('choosebookieOrder', JSON.stringify(choosebookieOrder));
        }

        $bookmakerContainer.empty();
        $bookmakerContainer.append($bookmakerNodes);
        this.setPositionAtribute($bookmakerNodes);

        if (!jQuery.cookie('chooseBookie')) {
            this.selectBookmaker(jQuery($bookmakerNodes[0]));
        }
    }

    setPositionAtribute($bookmakerNodes) {
        for (let i = 0; i < $bookmakerNodes.length; i += 1) {
            jQuery($bookmakerNodes[i]).attr('data-position', i + 1);
        }
    }

    setSignedInBookmaker($bookmakerNode) {
        const feedName = $bookmakerNode.attr('data-feed');
        const accountInfo = this.getAccountInfo(feedName);
        const $accountNode = $bookmakerNode.find(accountSelector);

        $accountNode.removeClass(signedInClass);

        if (accountInfo.isLoggedIn) {
            if (!$accountNode.hasClass(signedInClass)) {
                $accountNode.addClass(signedInClass);
            }

            $accountNode
                .find(`${accountSelector}BalanceValue`)
                .text(accountInfo.balance.toLocaleString());
        }
    }

    setSignedOutBookmaker($bookmakerNode) {
        const $accountNode = $bookmakerNode.find(accountSelector);

        $accountNode.removeClass(signedInClass);
    }

    getAccountInfo(feedName) {
        const accounts = JSON.parse(localStorage.getItem('userAccountsInfo'));
        const accountInfo = accounts && accounts[feedName];

        if (accountInfo) {
            return {
                isLoggedIn: accountInfo.isLoggedIn,
                balance: accountInfo.balance,
            };
        }

        return {
            isLoggedIn: false,
            balance: null,
        };
    }

    getLogoutDetails(feedName) {
        const accounts = JSON.parse(localStorage.getItem('userAccountsInfo'));
        const {
            apiName,
            feed,
            isCASLogout,
        } = accounts[feedName];

        if (accounts[feedName]) {
            return {
                apiName,
                feed,
                isCASLogout: isCASLogout || false,
            };
        }

        return false;
    }

    onButtonClick(event) {
        const $bookmakerChosen = jQuery(event.target).closest(bookmakerSelector);

        this.selectBookmaker($bookmakerChosen);
    }

    chooseBookieHandler() {
        const feedName = jQuery(`.${bookmakerSelectedClass}`).attr('data-feed');
        if (feedName) {
            jQuery.cookie('chooseBookie', feedName, {
                domain: `.${location.host.split('.').slice(1).join('.')}`,
                path: '/',
                expires: 365
            });

            if (!this.isOnLoad) {
                const betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.SET', {
                    detail: { bookmaker: feedName },
                });
                document.dispatchEvent(betslipEvent);
            }
        }
        this.closeModal();
        this.resolvePromise(feedName);
    }

    getSelectedBookmakerNode() {
        const feedName = jQuery.cookie('chooseBookie');

        if (feedName) {
            return jQuery(`${bookmakerSelector}[data-feed="${feedName}"]`);
        }

        return false;
    }

    selectBookmaker($bookmakerChosen) {
        if ($bookmakerChosen[0].classList.contains(bookmakerSelectedClass)) {
            return;
        }

        if (!this.$template[0].classList.contains(popoverSelectedClass)) {
            jQuery(linkSelector).removeClass('ui-btn--disabled');

            this.$template
                .on('click', linkSelector, this.chooseBookieHandler.bind(this));
            this.$template
                .addClass(popoverSelectedClass);
        }

        jQuery(bookmakerSelector).removeClass(bookmakerSelectedClass);
        $bookmakerChosen.addClass(bookmakerSelectedClass);

        this.setSignedInBookmaker($bookmakerChosen);
    }

    closeModal() {
        cardPage.addScroll();

        if (this.isOnLoad) {
            this.$template.rpModalBox('close');
        } else {
            jQuery(`.${overlayClass}`).hide();
        }
    }

    logInBookieHandler() {
        const $selectedBookmakerNode = jQuery(`.${bookmakerSelectedClass}`);
        const feedName = $selectedBookmakerNode.attr('data-feed');
        const bookiePosition = parseInt($selectedBookmakerNode.attr('data-position'), 10);

        this.chooseBookieHandler();
        const betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.LOGIN', {
            detail: {
                bookmaker: feedName,
                position: bookiePosition,
            },
        });
        document.dispatchEvent(betslipEvent);
    }

    registerBookieHandler() {
        const $selectedBookmakerNode = jQuery(`.${bookmakerSelectedClass}`);
        const feedName = $selectedBookmakerNode.attr('data-feed');
        const bookiePosition = parseInt($selectedBookmakerNode.attr('data-position'), 10);
        const bookieName = configBookieNames[feedName];
        const config = {
            [segmentio.TRAIT_BOOKMAKER]: bookieName,
            [segmentio.TRAIT_LOCATION]: 'Choose Your Bookie',
            [segmentio.TRAIT_POSITION]: bookiePosition,
        };

        segmentio.trackBookmakerRegister(config);
    }

    logOutBookieHandler() {
        const $selectedBookmaker = jQuery(`.${bookmakerSelectedClass}`);
        const feedName = $selectedBookmaker.attr('data-feed');
        const logoutDetails = this.getLogoutDetails(feedName);

        if (logoutDetails) {
            const betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.LOGOUT', {
                detail: logoutDetails,
            });

            document.dispatchEvent(betslipEvent);
            this.setSignedOutBookmaker($selectedBookmaker);
        }
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/chooseBookieExperiment.js